var banners = document.querySelectorAll('.banner');

if (banners.length > 0) {
    banners.forEach(function(banner) {
      const video = banner.querySelector('video');
      const backup = banner.querySelector('.backup-image.hidden');
    
      if (video && backup) {
        video.play().catch(function(error) {
          if (error.name === "NotAllowedError") {
            video.remove();
            backup.classList.remove('hidden');
          }
        });
      }
    });
}